import { Status } from '@/interfaces/status';
import { statusResource, StatusResource } from '@/resources/status.resource';
import { EntityModule } from '../entity.module';

/**
 * Moduł statusów dokumentu
 *
 * @export
 * @class DocumentStatusModule
 * @extends {EntityModule<Status, StatusResource>}
 */
export class DocumentStatusModule extends EntityModule<Status, StatusResource> {
  constructor() {
    super(statusResource);
  }
}

export default new DocumentStatusModule();
